import React, { useState, useEffect, useRef } from "react";
import { Table, Input, Button, Space, Popconfirm, message, Tooltip } from "antd";
import { PlusOutlined, EditOutlined, DeleteOutlined } from "@ant-design/icons";
import axios from "axios";
import "./categoryGroup.scss";
import GroupModal from "./Model/categoryGroup";
const BASE_URL = process.env.REACT_APP_CSC_API_BASE_URL;


const columnsBase = [
  {
    title: "#",
    dataIndex: "index",
    key: "index",
    width: 70,
    align: "center",
  },
  {
    title: "Group Name",
    dataIndex: "name",
    key: "name",
  },
  {
    title: "Priority",
    dataIndex: "priority",
    key: "priority",
  },
];

const CategoryGroup = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchInput, setSearchInput] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [editData, setEditData] = useState(null);
  const searchRef = useRef();

  // Fetch groups
  const fetchGroups = async () => {
    setLoading(true);
    try {
      const res = await axios.get(`${BASE_URL}service-groups`);
      const payload = res.data.payload || [];
      setData(
        payload.map((item, idx) => ({
          ...item,
          index: idx + 1,
        }))
      );
      setFilteredData(payload.map((item, idx) => ({ ...item, index: idx + 1 })));
    } catch (err) {
      setData([]);
      setFilteredData([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchGroups();
  }, []);

  // Debounced search (client-side)
  const handleSearch = (e) => {
    const value = e.target.value;
    setSearchInput(value);
    if (searchRef.current) clearTimeout(searchRef.current);
    searchRef.current = setTimeout(() => {
      if (!value) {
        setFilteredData(data);
      } else {
        setFilteredData(
          data.filter(
            (item) =>
              item.name?.toLowerCase().includes(value.toLowerCase())
          )
        );
      }
    }, 400);
  };

  // Add/Edit Modal
  const openAddModal = () => {
    setEditData(null);
    setModalOpen(true);
  };
  const openEditModal = (row) => {
    setEditData(row);
    setModalOpen(true);
  };
  const closeModal = (refresh = false) => {
    setModalOpen(false);
    setEditData(null);
    if (refresh) fetchGroups();
  };

  // Delete
  const handleDelete = async (row) => {
    try {
      await axios.delete(`${BASE_URL}service-groups/${row.service_group_id}`);
      message.success("Group deleted!");
      fetchGroups();
    } catch {
      message.error("Failed to delete group");
    }
  };

  // Columns with actions
  const columns = [
    ...columnsBase,
    {
      title: "Actions",
      key: "actions",
      render: (_, row) => (
        <Space>
          <Tooltip title="Edit">
            <Button icon={<EditOutlined />} onClick={() => openEditModal(row)} />
          </Tooltip>
          <Popconfirm
            title="Are you sure to delete this group?"
            onConfirm={() => handleDelete(row)}
            okText="Yes"
            cancelText="No"
          >
            <Button icon={<DeleteOutlined />} danger />
          </Popconfirm>
        </Space>
      ),
    },
  ];

  return (
    <div className="mainContain">
      <h1 className="transaction">All Category Groups</h1>
      <div style={{ marginBottom: 16, display: "flex", justifyContent: "space-between" }}>
        <Input.Search
          placeholder="Search Group"
          allowClear
          value={searchInput}
          onChange={handleSearch}
          style={{ width: 300 }}
        />
        <Button type="primary" icon={<PlusOutlined />} onClick={openAddModal}>
          Add Group
        </Button>
      </div>
      <Table
        columns={columns}
        dataSource={filteredData}
        loading={loading}
        rowKey="service_group_id"
        pagination={false}
        scroll={{ x: 600 }}
      />
      <GroupModal
        open={modalOpen}
        onClose={closeModal}
        editData={editData}
      />
    </div>
  );
};


export default CategoryGroup;